/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancellation_ScheduledInputs */

const en_cancellation_scheduled = /** @type {(inputs: Cancellation_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellation Scheduled`)
};

const fr_cancellation_scheduled = /** @type {(inputs: Cancellation_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulation prévue`)
};

const de_cancellation_scheduled = /** @type {(inputs: Cancellation_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornierung geplant`)
};

const it_cancellation_scheduled = /** @type {(inputs: Cancellation_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellazione programmata`)
};

const ru_cancellation_scheduled = /** @type {(inputs: Cancellation_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена запланированного рейса`)
};

const es_cancellation_scheduled = /** @type {(inputs: Cancellation_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelación programada`)
};

const zh_cn2_cancellation_scheduled = /** @type {(inputs: Cancellation_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已安排取消`)
};

const ja_cancellation_scheduled = /** @type {(inputs: Cancellation_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル予定`)
};

const hi_cancellation_scheduled = /** @type {(inputs: Cancellation_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करने की योजना बनाई गई है`)
};

const pt_pt2_cancellation_scheduled = /** @type {(inputs: Cancellation_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelamento agendado`)
};

/**
* | output |
* | --- |
* | "Cancellation Scheduled" |
*
* @param {Cancellation_ScheduledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cancellation_scheduled = /** @type {((inputs?: Cancellation_ScheduledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancellation_ScheduledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cancellation_scheduled(inputs)
	if (locale === "de") return de_cancellation_scheduled(inputs)
	if (locale === "it") return it_cancellation_scheduled(inputs)
	if (locale === "ru") return ru_cancellation_scheduled(inputs)
	if (locale === "es") return es_cancellation_scheduled(inputs)
	if (locale === "zh-CN") return zh_cn2_cancellation_scheduled(inputs)
	if (locale === "ja") return ja_cancellation_scheduled(inputs)
	if (locale === "hi") return hi_cancellation_scheduled(inputs)
	if (locale === "pt-PT") return pt_pt2_cancellation_scheduled(inputs)
	return en_cancellation_scheduled(inputs)
});